import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { ElioSvgIconsModule } from '@elio/shared/icon-utils';

@Component({
  selector: 'elio-loading',
  template: `<elio-svg-icon class="animate-spin" key="cutted-circle"></elio-svg-icon>`,
  host: {
    class: 'flex flex-grow justify-center h-full items-center',
  },
  standalone: true,
  imports: [ElioSvgIconsModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ElioLoadingComponent {
  @HostBinding('class')
  @Input()
  size = 'text-5xl';
}
